import React, { useState, useEffect } from 'react';
import { Table, Space, Modal } from 'antd';
import { API_BASE_URL } from '../services/apiConfig';
import AuthService from '../services/auth.service';
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { EditOutlined, DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
interface QuestionnaireItem {
  name: string;
  input: string[];
}

interface Reservation {
  reservationSeq: number;
  created: string;
  mobileNumber: string;
  questionnaire: string;
  confirmFlag: boolean;
  reservationDate: string;
}

interface ReservationListViewProps {
  SelectValue: string;
  selectedClubInfo: any; // Replace with correct type
  selectmemberidsoket: any;
  onselectedDeviceNameChange: (selectedDeviceName: any) => void;
  onselectchangeupdate: (selectchangeroom: any) => void;
  profiledata: any;
}

const ReservationListView: React.FC<ReservationListViewProps> = ({
  SelectValue,
  selectedClubInfo,
  selectmemberidsoket,
  onselectedDeviceNameChange,
  profiledata,
  onselectchangeupdate,
}) => {
  const [pendingReservations, setPendingReservations] = useState<Reservation[]>([]);
  const [completedReservations, setCompletedReservations] = useState<Reservation[]>([]);
  const [selectedReservation, setSelectedReservation] = useState<Reservation | null>(null);
  const [stompClient, setStompClient] = useState<Stomp.Client | null>(null);
  const [modalVisible, setModalVisible] = useState(false);

  // Pagination state
  const [completedPage, setCompletedPage] = useState(1);
  const [completedPageSize, setCompletedPageSize] = useState(10);
  const [completedTotal, setCompletedTotal] = useState(0);

  useEffect(() => {
    if (!stompClient || !stompClient.connected) {
      console.log("소켓 실행");
      console.log("소켓 아이디 : " + selectmemberidsoket);

      const newSocket = new SockJS(API_BASE_URL + "/ws");
      const newStomp = Stomp.over(newSocket);

      const headers = { 'sender': selectmemberidsoket, 'type': 'reservation' };
      if (newStomp && newStomp.connected) {
        console.log("WebSocket 연결이 해제되었습니다.");
        newStomp.disconnect(() => {
          console.log("WebSocket 연결이 성공적으로 종료되었습니다.");
        });
      }
      newStomp.connect(
        headers,
        function (frame) {
          console.log("연결 성공 : " + `/queue/reservation/${selectmemberidsoket}`);

          newStomp.subscribe(`/queue/reservation/${selectmemberidsoket}`, (message) => {
            try {
              console.log("리프레시 실행");
              fetchReservationDataAPI();
            } catch (error) {
              console.error("Error parsing message:", error);
            }
          });

          setStompClient(newStomp);
        },
        (error) => {
          console.error("Error during WebSocket connection:", error);
        }
      );
      newStomp.ws.onclose = () => {
        console.log("WebSocket 연결이 끊어졌습니다.");
        setStompClient(null);
      };

      newStomp.ws.onerror = () => {
        console.log("WebSocket 연결 에러.");
        setStompClient(null);
      };
    }

    return () => {
      if (stompClient) {
        stompClient.disconnect(() => {
          console.log("WebSocket 연결이 해제되었습니다.");
        });
      }
    };
  }, []);

  useEffect(() => {
    fetchReservationDataAPI();
  }, [completedPage, completedPageSize]);

  const fetchReservationDataAPI = async () => {
    try {
      const responsePending = await fetch(`${API_BASE_URL}/reservation/${selectedClubInfo?.club_seq}/false`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${AuthService.getRawToken()}`,
          'Content-Type': 'application/json',
        },
      });
      const dataPending = await responsePending.json();
      console.log("예약리스트 : " + JSON.stringify(dataPending,null,2))

      if (dataPending && dataPending.data && dataPending.data.reservationList && dataPending.data.reservationList.content) {
        const pending: Reservation[] = dataPending.data.reservationList.content.filter((reservation: Reservation) => !reservation.confirmFlag);
        setPendingReservations(pending);
      } else {
        console.error('Invalid API response structure for pending reservations:', dataPending);
      }

      const responseCompleted = await fetch(`${API_BASE_URL}/reservation/${selectedClubInfo?.club_seq}/true?page=${completedPage - 1}&size=${completedPageSize}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${AuthService.getRawToken()}`,
          'Content-Type': 'application/json',
        },
      });
      const dataCompleted = await responseCompleted.json();

      if (dataCompleted && dataCompleted.data && dataCompleted.data.reservationList && dataCompleted.data.reservationList.content) {
        const completed: Reservation[] = dataCompleted.data.reservationList.content.filter((reservation: Reservation) => reservation.confirmFlag);
        setCompletedReservations(completed);
        setCompletedTotal(dataCompleted.data.reservationList.totalElements);
      } else {
        console.error('Invalid API response structure for completed reservations:', dataCompleted);
      }
    } catch (error) {
      console.error('(ReservationListView) Error fetching data:', error);
    }
  };


  const handleReservationConfirmed = (record: Reservation) => {
    fetch(`${API_BASE_URL}/reservation/${selectedClubInfo?.club_seq}/${record.reservationSeq}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${AuthService.getRawToken()}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        console.log("예약 확정");
        fetchReservationDataAPI();
      })
      .catch(error => {
        console.error('There was an error with the PATCH request:', error);
      });
  };
  const { confirm } = Modal;
  const handleCancelReservation = (record: Reservation) => {

    confirm({
      title: "예약 취소",
      icon: <ExclamationCircleOutlined />,
      content: '정말 취소하시겠습니까?',
      okText: '취소',
      okType: 'danger',
      cancelText: '취소',
      onOk() {

          fetch(`${API_BASE_URL}/reservation/${selectedClubInfo?.club_seq}/${record.reservationSeq}`, {
            method: "DELETE",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${AuthService.getRawToken()}`,
            },
          })
            .then((response) => {
              if (!response.ok) {
                throw new Error('Network response was not ok ' + response.statusText);
              }
              return response.json();
            })
            .then((data) => {
              console.log('Success:', data);
              fetchReservationDataAPI();
            })
            .catch((error) => {
              console.error('Error:', error);
            });
      },
      onCancel() {
          console.log('취소되었습니다.');
      },
  });
  




  };

  const handleViewDetails = (record: Reservation) => {
    setSelectedReservation(record);
    setModalVisible(true);
  };

  const closeModal = () => {
    setSelectedReservation(null);
    setModalVisible(false);
  };

  const handleCompletedTableChange = (pagination: any) => {
    setCompletedPage(pagination.current);
    setCompletedPageSize(pagination.pageSize);
  };

  const columns = [

    {
      title: '예약날짜',
      dataIndex: 'questionnaire',
      key: 'reservationDate',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          
          const reservationDate = parsedQuestionnaire.find((item) => item.name === '예약 날짜')?.input.join(', ');
          return reservationDate || '-';
        } catch (error) {
          console.error('Error parsing questionnaire:', error);
          return '-';
        }
      },
    },
    {
      title: '예약 가능 시간대',
      dataIndex: 'questionnaire',
      key: 'reservationTime',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          const reservationTime = parsedQuestionnaire.find((item) => item.name === '예약 가능 시간대')?.input.join(', ');
          return reservationTime || '-';
        } catch (error) {
          return '-';
        }
      },
    },
    {
      title: '진료 분야',
      dataIndex: 'questionnaire',
      key: 'fieldsOfCare',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          const fieldsOfCare = parsedQuestionnaire.find((item) => item.name === '진료 분야')?.input.join(', ');
          return fieldsOfCare || '-';
        } catch (error) {
          return '-';
        }
      },
    },
    {
      title: '성명',
      dataIndex: 'questionnaire',
      key: 'name',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          const name = parsedQuestionnaire.find((item) => item.name === '성명')?.input[0];
          return name || '-';
        } catch (error) {
          return '-';
        }
      },
    },
    {
      title: '핸드폰 번호',
      dataIndex: 'mobileNumber',
      key: 'phoneNumber',
    },
    {
      title: '동작',
      key: 'action',
      render: (text: any, record: Reservation) => (
        <Space size="middle">
          <a onClick={() => handleViewDetails(record)}>상세 정보 보기</a>
          <a onClick={() => handleReservationConfirmed(record)}>예약확정</a>
          <a onClick={() => handleCancelReservation(record)}>예약 취소</a>
        </Space>
      ),
    },
  ];

  const columns1 = [
    {
      title: '예약날짜',
      dataIndex: 'questionnaire',
      key: 'reservationDate',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          const reservationDate = parsedQuestionnaire.find((item) => item.name === '예약 날짜')?.input.join(', ');
          return reservationDate || '-';
        } catch (error) {
          console.error('Error parsing questionnaire:', error);
          return '-';
        }
      }
    },
    {
      title: '예약 가능 시간대',
      dataIndex: 'questionnaire',
      key: 'reservationTime',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          const reservationTime = parsedQuestionnaire.find((item) => item.name === '예약 가능 시간대')?.input.join(', ');
          return reservationTime || '-';
        } catch (error) {
          console.error('Error parsing questionnaire:', error);
          return '-';
        }
      },
    },
    {
      title: '진료 분야',
      dataIndex: 'questionnaire',
      key: 'fieldsOfCare',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          const fieldsOfCare = parsedQuestionnaire.find((item) => item.name === '진료 분야')?.input.join(', ');
          return fieldsOfCare || '-';
        } catch (error) {
          console.error('Error parsing questionnaire:', error);
          return '-';
        }
      },
    },
    {
      title: '성명',
      dataIndex: 'questionnaire',
      key: 'name',
      render: (questionnaire: string) => {
        try {
          const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(questionnaire).예약;
          const name = parsedQuestionnaire.find((item) => item.name === '성명')?.input[0];
          return name || '-';
        } catch (error) {
          console.error('Error parsing questionnaire:', error);
          return '-';
        }
      },
    },
    {
      title: '핸드폰 번호',
      dataIndex: 'mobileNumber',
      key: 'phoneNumber',
    },
    {
      title: '동작',
      key: 'action',
      render: (text: any, record: Reservation) => (
        <Space size="middle">
          <a onClick={() => handleViewDetails(record)}>상세 정보 보기</a>
        </Space>
      ),
    },
  ];

  const parseQuestionnaireItem = (itemName: string): string => {
    try {
      if (!selectedReservation) {
        return '-';
      }

      const parsedQuestionnaire: QuestionnaireItem[] = JSON.parse(selectedReservation.questionnaire).예약;
      const item = parsedQuestionnaire.find((item) => item.name === itemName)?.input[0];
      return item || '-';
    } catch (error) {
      console.error(`Error parsing ${itemName} from questionnaire:`, error);
      return '-';
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', margin:"50px" }}>
      {/* 예약 중인 정보 */}
      <div style={{ width: '45%' }}>
        <h2>예약 중인 리스트</h2>
        <Table columns={columns} dataSource={pendingReservations} pagination={false} />
      </div>
      {/* 예약 완료된 정보 */}
      <div style={{ width: '45%' }}>
        <h2>예약 완료 리스트</h2>
        <Table
          columns={columns1}
          dataSource={completedReservations}
          pagination={{
            current: completedPage,
            pageSize: completedPageSize,
            total: completedTotal,
          }}
          onChange={handleCompletedTableChange}
        />
      </div>
      {/* 예약 상세 모달 */}
      <Modal
        title="예약 상세 정보"
        visible={modalVisible}
        onCancel={closeModal}
        footer={null}
      >
        {selectedReservation && (
          <div>
            <p><strong>예약 날짜:</strong> {parseQuestionnaireItem('예약 날짜')}</p>
            <p><strong>예약 가능 시간대:</strong> {parseQuestionnaireItem('예약 가능 시간대')}</p>
            <p><strong>진료 분야:</strong> {parseQuestionnaireItem('진료 분야')}</p>
            <p><strong>현재 복용 중인 약물:</strong> {parseQuestionnaireItem('현재 복용 중인 약물')}</p>
            <p><strong>과거 병력:</strong> {parseQuestionnaireItem('과거 병력')}</p>
            <p><strong>입원 경험:</strong> {parseQuestionnaireItem('입원 경험')}</p>
            <p><strong>수술 경험:</strong> {parseQuestionnaireItem('수술 경험')}</p>
            <p><strong>알러지 유무:</strong> {parseQuestionnaireItem('알러지 유무')}</p>
            <p><strong>개인정보 수집 동의:</strong> {parseQuestionnaireItem('개인정보 수집 동의')}</p>
            <p><strong>성명:</strong> {parseQuestionnaireItem('성명')}</p>
            <p><strong>생년월일:</strong> {parseQuestionnaireItem('생년월일')}</p>
            <p><strong>성별:</strong> {parseQuestionnaireItem('성별')}</p>
            <p><strong>핸드폰 번호:</strong> {selectedReservation.mobileNumber}</p>
            <p><strong>첫 방문이신가요?:</strong> {parseQuestionnaireItem('첫 방문이신가요?')}</p>
          </div>
        )}
      </Modal>
    </div>
  );
};

export default ReservationListView;
